// auth.js - 认证工具函数
export const checkAuth = () => {
  return !!localStorage.getItem('token'); // 或者你的 token 存储方式
};

export const getToken = () => {
  return localStorage.getItem('token');
};